module.exports = __webpack_public_path__ + "img/fCPoeYsZ.7dcb6ae4.svg";